import React from 'react'
import { css } from '@emotion/css'
import { Dropdown } from '../dropdown'
import { DropdownProps, DropdownStyleOverrides } from '../dropdown/dropdown'

const styleOverrides = (hideArrow: boolean): DropdownStyleOverrides => ({
  selectionContainerCss: css`
    padding-left: 8px;
    padding-right: 8px;

    &:not(:hover) {
      background-image: none;
      border-color: transparent;
    }
  `,
  menuItemContainerCss: css`
    padding-left: 8px;
    padding-right: 8px;
  `,
  menuCss: css`
    top: -5px;
    border-width: 1px;
    width: auto;
  `,
  outerContainerCss: css`
    width: auto;
  `,
  arrowColor: !hideArrow ? 'transparent' : undefined
})

export function EditableTextDropdown<T>(props: DropdownProps<T>) {
  let hideArrow = true

  if (props.hideArrow) {
    hideArrow = props.hideArrow
  }

  return (
    <Dropdown
      hideArrow={hideArrow}
      {...props}
      styleOverrides={styleOverrides(hideArrow)}
    />
  )
}
